import {
  jb_region_indicator_css_default
} from "./chunk.IXFE4M5J.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  attachInterestEvents
} from "./chunk.AHMM4X2O.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-region-indicator/jb-region-indicator.ts
var JbRegionIndicator = class extends i {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      label: "Change your current location and language"
    };
    this._hovered = false;
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    attachInterestEvents(this._activeElement);
  }
  _renderItem(item) {
    return b`<span class="indicator-item">
      ${item.hasGlobe ? b`<jb-icon
                iconName="animated:globe"
                class="${e2({ hover: this._hovered })}"
              ></jb-icon
              ><span class="short">${item.text}</span><span>${item.textFull}</span>` : b`<span class="short">${item.text}</span><span>${item.textFull}</span>`}
    </span>`;
  }
  render() {
    return b`<button
      @click=${(e3) => {
      e3.preventDefault();
      this.dispatchEvent(new CustomEvent("region-indicator:clicked", { bubbles: true, composed: true }));
    }}
      @keydown=${(e3) => {
      if (e3.key === "Enter" || e3.code === "Space") {
        e3.preventDefault();
        e3.target.click();
      }
    }}
      @interest=${() => {
      this._hovered = true;
    }}
      @loseinterest=${() => {
      this._hovered = false;
    }}
    >
      <span class="sr-only">${this.ariaLabels?.label ?? this.ARIALABELS_DEFAULT.label}</span>
      <div>${this.items?.map((item) => this._renderItem(item))}</div>
    </button>`;
  }
};
JbRegionIndicator.styles = [reset_css_default, jb_region_indicator_css_default];
__decorateClass([
  n({ type: Object })
], JbRegionIndicator.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Array })
], JbRegionIndicator.prototype, "items", 2);
__decorateClass([
  e("button")
], JbRegionIndicator.prototype, "_activeElement", 2);
__decorateClass([
  r()
], JbRegionIndicator.prototype, "_hovered", 2);
JbRegionIndicator = __decorateClass([
  customElement("jb-region-indicator")
], JbRegionIndicator);

export {
  JbRegionIndicator
};
